<template>
  <div class="p-2 bg-white sticky top-0 z-20" :class="{'shadow': isStuck}" ref="tabSwitcher">
    <div class="flex flex-row p-1 mx-auto rounded-full border border-solid"
    :class="{
      'border-green-300': activeTab === 0,
      'border-blue-300': activeTab === 1,
    }"
    style="max-width: 452px;">
      <TabSwitcherItem
        v-for="tab in tabs"
        :key="tab.id"
        :label="belowSmBreakpoint ? tab.shortLabel : tab.label"
        :isActive="activeTab === tab.id"
        :id="tab.id"
        @click="(id) => handleClick(id, tab)"
      />
    </div>
  </div>
</template>

<script>
import TabSwitcherItem from "./TabSwitcherItem";
export default {
  props: {
    value: Number,
    tabs: { type: Array },
  },
  components: {
    TabSwitcherItem,
  },
  data() {
    return {
      activeTab: 0,
      isStuck: false
    };
  },
  watch: {
    value(value) {
      this.activeTab = value;
    },
  },
  computed: {
    belowSmBreakpoint() {
      return ["xs", "mobile"].includes(this.$mq);
    },
  },
  methods: {
    handleClick(id, tab) {
      this.$emit("tab-change", tab);
      this.activeTab = id;
    },
    handleScroll(e) {
      this.$nextTick(()=>{
        if (this.$refs.tabSwitcher.getBoundingClientRect().top === 0 ) {
          this.isStuck = true;
        } else {
          this.isStuck = false;
        }
      });
    }
  },
  beforeMount() {
    this.activeTab = this.value !== undefined ? this.value : 0;
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false);
  }
};
</script>

<style scoped>
</style>
